import { Database, BarChart3, Award, Leaf } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const SustainwizeFeaturesSection = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: Database,
      titleKey: "sustainwize.feature1Title",
      descKey: "sustainwize.feature1Desc"
    },
    {
      icon: BarChart3,
      titleKey: "sustainwize.feature2Title",
      descKey: "sustainwize.feature2Desc"
    },
    {
      icon: Award,
      titleKey: "sustainwize.feature3Title",
      descKey: "sustainwize.feature3Desc"
    },
    {
      icon: Leaf,
      titleKey: "sustainwize.feature4Title",
      descKey: "sustainwize.feature4Desc"
    }
  ];

  return (
    <section id="features" className="py-24 lg:py-32 bg-background relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#fd6158]/10 rounded-full blur-3xl opacity-30" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#373530] mb-4">
            {t("sustainwize.featuresTitle")}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t("sustainwize.featuresSubtitle")}
          </p>
        </div>

        {/* Four Pillars */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group text-center p-8 rounded-3xl bg-gradient-to-b from-white to-[#f9fafb] border border-border/50 shadow-sm hover:shadow-xl hover:border-[#fd6158]/30 transition-all duration-300"
            >
              <div className="w-16 h-16 rounded-2xl bg-[#fd6158]/10 flex items-center justify-center mx-auto mb-6 group-hover:bg-[#fd6158]/20 transition-colors duration-300">
                <feature.icon className="w-8 h-8 text-[#fd6158]" />
              </div>
              <h3 className="text-lg lg:text-xl font-bold text-[#373530] mb-3">{t(feature.titleKey)}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{t(feature.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SustainwizeFeaturesSection;
